import { FAQ } from "../../types/faq";
import { DeviceType, RepairService, Brand, RepairProcessStep } from "../../types/home";

// JSON data for device types
export const deviceTypes: DeviceType[] = [
  {
    id: 1,
    name: "SmartPhone",
    image: 'uploads/2025/02/Crack_Point_Smartphone.png',
    description: "Provides fast, reliable repairs for all smartphone issues, ensuring quality service every time."
  },
  {
    id: 2,
    name: "Tablet",
    image: 'uploads/2025/02/Crack_Point_tablet.png',
    description: "Offers fast, reliable tablet repairs, ensuring your device is back to perfect condition in no time."
  },
  {
    id: 3,
    name: "Feature Phone",
    image: 'uploads/2025/02/Crack_Point_Jio_Phone.png',
    description: "Provides quick and reliable repairs for feature phones, ensuring they stay functional and ready to use."
  },
  {
    id: 4,
    name: "Smart Watch",
    image: 'uploads/2025/02/Crack_Point_smart_watch.png',
    description: "Efficient smartwatch repair: swift, accurate service to keep your device flawless and connected."
  }
];

// JSON data for smartphone repair services
export const smartphoneRepairs: RepairService[] = [
  {
    id: 1,
    name: "Mobile Display Repair",
    image: "uploads/2025/02/Crack_Point_mobile-display-replacement-–-2.png"
  },
  {
    id: 2,
    name: "Mobile Touch Screen Repair",
    image: "uploads/2025/02/Crack_Point_mobile-display-replacement-–-41.png"
  },
  {
    id: 3,
    name: "Mobile Battery Repair",
    image: "uploads/2025/02/Crack_Point_mobile-battery-replacement-–-1.png"
  },
  {
    id: 4,
    name: "Mobile Back Glass Repair",
    image: "uploads/2025/02/Crack_Point_mobile-back-glass-replacement.png"
  },
  {
    id: 5,
    name: "Mobile Charging Repair",
    image: "uploads/2025/02/Crack_Point_mobile-display-replacement-–-3.png"
  },
  {
    id: 6,
    name: "Mobile Camera Glass Repair",
    image: "uploads/2025/02/Crack_Point_mobile-display-replacement-–-5.png"
  },
  {
    id: 7,
    name: "Mobile Speaker Repair",
    image: "uploads/2025/02/Crack_Point_mobile-display-replacement-–-6.png"
  },
  {
    id: 8,
    name: "Mobile Mic Repair",
    image: "uploads/2025/02/Crack_Point_mobile-display-replacement-–-7.png"
  },
  {
    id: 9,
    name: "Mobile Power Button Repair",
    image: "uploads/2025/02/Crack_Point_mobile-display-replacement-–-8.png"
  },
  {
    id: 10,
    name: "Mobile Water Damage Repair",
    image: "uploads/2025/02/Crack_Point_mobile-display-replacement-–-9.png"
  },
  {
    id: 11,
    name: "Motherboard Repair",
    image: "uploads/2025/02/Crack_Point_mobile-display-replacement-–-10.png"
  },
  {
    id: 12,
    name: "Mobile Software Repair",
    image: "uploads/2025/02/Crack_Point_mobile-display-replacement-–-11.png"
  }
];

// JSON data for tablet repair services
export const tabletRepairs: RepairService[] = [
  {
    id: 1,
    name: "Tablet Water Damage Repair",
    image: "uploads/2025/02/Crack_Point_mobile-display-replacement-–-21.png"
  },
  {
    id: 2,
    name: "Tablet Touch Screen Repair",
    image: "uploads/2025/02/Crack_Point_mobile-display-replacement-–-24.png"
  },
  {
    id: 3,
    name: "Tablet Battery Repair",
    image: "uploads/2025/02/Crack_Point_mobile-display-replacement-–-22.png"
  },
  {
    id: 4,
    name: "Tablet Water Damage Repair",
    image: "uploads/2025/02/Crack_Point_mobile-display-replacement-–-28.png"
  },
  {
    id: 5,
    name: "Tablet Charging Repair",
    image: "uploads/2025/02/Crack_Point_mobile-display-replacement-–-23.png"
  },
  {
    id: 6,
    name: "Tablet Power Button Repair",
    image: "uploads/2025/02/Crack_Point_mobile-display-replacement-–-26.png"
  },
  {
    id: 7,
    name: "Tablet Camera Repair",
    image: "uploads/2025/02/Crack_Point_mobile-display-replacement-–-25.png"
  },
  {
    id: 8,
    name: "Tablet Speaker Repair",
    image: "uploads/2025/02/Crack_Point_mobile-display-replacement-–-30.png"
  },
  {
    id: 9,
    name: "Motherboard Repair",
    image: "uploads/2025/02/Crack_Point_mobile-display-replacement-–-27.png"
  },
  {
    id: 10,
    name: "Tablet Software Repair",
    image: "uploads/2025/02/Crack_Point_mobile-display-replacement-–-29.png"
  }
];

// JSON data for feature phone repair services
export const featurePhoneRepairs: RepairService[] = [
  {
    id: 1,
    name: "Mobile Display Repair",
    image: "uploads/2025/02/Crack_Point_mobile-display-replacement-–-31.png"
  },
  {
    id: 2,
    name: "Mobile Battery Repair",
    image: "uploads/2025/02/Crack_Point_mobile-display-replacement-–-32.png"
  },
  {
    id: 3,
    name: "Mobile Speaker Repair",
    image: "uploads/2025/02/Crack_Point_mobile-display-replacement-–-34.png"
  },
  {
    id: 4,
    name: "Mobile Mic Repair",
    image: "uploads/2025/02/Crack_Point_mobile-display-replacement-–-35.png"
  },
  {
    id: 5,
    name: "Mobile Body Repair",
    image: "uploads/2025/02/Crack_Point_mobile-display-replacement-–-36.png"
  },
  {
    id: 6,
    name: "Motherboard Repair",
    image: "uploads/2025/02/Crack_Point_mobile-display-replacement-–-33.png"
  },
  {
    id: 7,
    name: "Mobile Software Repair",
    image: "uploads/2025/02/Crack_Point_mobile-display-replacement-–-11.png"
  }
];

// JSON data for smart watch repair services
export const smartWatchRepairs: RepairService[] = [
  {
    id: 1,
    name: "Smart Watch Display Repair",
    image: "uploads/2025/02/Crack_Point_mobile-display-replacement-–-37.png"
  },
  {
    id: 2,
    name: "Smart Watch Battery Repair",
    image: "uploads/2025/02/Crack_Point_mobile-display-replacement-–-38.png"
  },
  {
    id: 3,
    name: "Smart Watch Touch Repair",
    image: "uploads/2025/02/Crack_Point_mobile-display-replacement-–-42.png"
  },
  {
    id: 4,
    name: "Water Damage Repair",
    image: "uploads/2025/02/Crack_Point_mobile-display-replacement-–-39.png"
  },
  {
    id: 5,
    name: "Motherboard Repair",
    image: "uploads/2025/02/Crack_Point_mobile-display-replacement-–-40.png"
  }
];

// JSON data for brands
export const brands: Brand[] = [
  { id: 1, name: "Motorola", image: "uploads/2025/02/Motorola.svg" },
  { id: 2, name: "Huawei", image: "uploads/2025/02/Huawei.svg" },
  { id: 3, name: "Asus", image: "uploads/2025/02/Asus.svg" },
  { id: 4, name: "Oppo", image: "uploads/2025/02/Oppo.svg" },
  { id: 5, name: "Apple", image: "uploads/2025/02/Apple.svg" },
  { id: 6, name: "Oneplus", image: "uploads/2025/02/OnePlus.svg" },
  { id: 7, name: "Googlepixel", image: "uploads/2025/02/Google.svg" },
  { id: 8, name: "Nokia", image: "uploads/2025/02/Nokia.svg" },
  { id: 9, name: "Samsung", image: "uploads/2025/02/Samsung.svg" },
];

export const repairBrands: Brand[] = [
  { id: 1, name: "Motorola", image: "uploads/2025/02/i-phone.png" },
  { id: 2, name: "Huawei", image: "uploads/2025/02/Opponew.png" },
  { id: 3, name: "Asus", image: "uploads/2025/02/Vivonew.png" },
  { id: 4, name: "Oppo", image: "uploads/2025/02/Xiaominew.png" },
  { id: 5, name: "Apple", image: "uploads/2025/02/Realme.png" },
  { id: 6, name: "Oneplus", image: "uploads/2025/02/OnePlusnew.png" },
  { id: 7, name: "Googlepixel", image: "uploads/2025/02/Samsungnew.png" },
  { id: 8, name: "Nokia", image: "uploads/2025/02/motorolanew.png" },
  { id: 10, name: "Samsung", image: "uploads/2025/02/Nokianew.png" },
  { id: 11, name: "Samsung", image: "uploads/2025/02/poconew.png" },
  { id: 12, name: "Samsung", image: "uploads/2025/02/iQoonew.png" },
  { id: 13, name: "Samsung", image: "uploads/2025/02/tecnonew.png" },
  { id: 14, name: "Samsung", image: "uploads/2025/02/Lgnew.png" },
  { id: 15, name: "Samsung", image: "uploads/2025/02/asusnew.png" },
  { id: 16, name: "Samsung", image: "uploads/2025/02/Lenovonew.png" },
  { id: 17, name: "Samsung", image: "uploads/2025/02/honornew.png" },
];

// JSON data for repair process steps
export const repairProcess: RepairProcessStep[] = [
  {
    id: 1,
    title: "Create a Job Sheet",
    description: "We document your device's issues, powered by PhoneLab Store, to keep track of all reported problems."
  },
  {
    id: 2,
    title: "Diagnosis and Repair",
    description: "Our certified technicians promptly diagnose and address the identified issues, ensuring a swift repair process."
  },
  {
    id: 3,
    title: "Testing & Quality Check",
    description: "Post-repair, our quality assurance team conducts thorough testing to confirm your device is functioning perfectly."
  },
  {
    id: 4,
    title: "Hassle-Free Payment",
    description: "Once the repair is complete, our billing team provides a detailed invoice, ensuring a smooth and transparent payment process."
  },
  {
    id: 5,
    title: "Service Warranty",
    description: "We offer 90 day warranty on our services, giving you peace of mind and confidence in the durability of our repairs."
  },
  {
    id: 6,
    title: "Feedback & Support",
    description: "Your satisfaction is paramount. We encourage feedback and are always available to assist with any post-service queries or support you may need."
  }
];

// JSON data for FAQs
export const faqs: FAQ[] = [
  {
    id: 1,
    question: "What services does PhoneLab offer?",
    answer: "PhoneLab specializes in smartphone repair, including screen replacement, battery replacement, water damage repair, software troubleshooting, and advanced chip-level repairs."
  },
  {
    id: 2,
    question: "How long does a typical repair take?",
    answer: "Most repairs, such as screen or battery replacements, are completed within 30-60 minutes. However, advanced repairs may take longer, depending on complexity and part availability."
  },
  {
    id: 3,
    question: "Do you provide a warranty on repairs?",
    answer: "Yes, we offer a warranty on most repairs. The warranty period varies depending on the type of repair and parts used. Please check with our team for details."
  },
  {
    id: 4,
    question: "Do you use original parts for repairs?",
    answer: "We use high-quality OEM or original parts whenever possible. We also offer premium third-party alternatives based on customer preferences."
  },
  {
    id: 5,
    question: "How much do repairs cost?",
    answer: "Yes, we offer a warranty on most repairs. The warranty period varies depending on the type of repair and parts used. Please check with our team for details."
  },
  {
    id: 6,
    question: "Can you recover data from a damaged phone?",
    answer: "Yes, we offer a warranty on most repairs. The warranty period varies depending on the type of repair and parts used. Please check with our team for details."
  },
  {
    id: 7,
    question: "How can I contact PhoneLab for support?",
    answer: "You can reach us via phone, WhatsApp, email, or by visiting our store. Check our Contact Us page for details."
  }
];

export const deviceProblems: string[] = [
  "What is your device problems",
  "Estimated Cost ?",
  "Display Problem Repair",
  // ... rest of your options
];

export const deviceBrands: string[] = [
  "Select Brand",
  "Apple",
  "Samsung",
];
